import { makeStyles } from '@material-ui/core/styles';

export const styles = {
  card: {
    padding: '10px',
    margin: '10px 0',
  },
};

export const useStyles = makeStyles(styles);
